import ZingTouch from 'zingtouch';
import gsap from 'gsap';
import { getCardinalDirection } from '../shared/helpers/ZingTouchHelper';


(() => {
	document.addEventListener('pageLoad', () => {
		const galleries = Array.from(document.querySelectorAll('.gallery'));
		if( galleries.length === 0 ) {
			return;
		}
		
		galleries.forEach( gallery => {
			const swipeEnabled = true;
			const nav = gallery.querySelector('.gallery--nav');
			const elements = Array.from(gallery.querySelectorAll('.gallery--item'));
			const currentClassname = 'current';
			const maxIndex = elements.length - 1;
			let currentIndex = 0;
			let current = null;
			
			if( elements.length < 2 && nav ) {
				nav.style.display = 'none';
			}
			
			if( elements.length === 0 ) {
				return;
			}
			
			const _videoPlay = (item, play) => {
				const video = item.querySelector('video');
				if(video) {
					play ? video.play() : video.pause();
				}
			}
			
			const _setIndex = (index, animate = true) => {
				let old = null;
				
				if( current ) {
					old = current;
					old.classList.remove(currentClassname);
					if( old.classList.contains('type-video') ) {
						_videoPlay(old, false);
					}
				}
				
				let newIndex = index;
				if( index > maxIndex ) {
					newIndex = 0;
				}
				else if( index < 0 ) {
					newIndex = maxIndex;
				}
				
				current = elements[newIndex];
				current.classList.add(currentClassname);
				if( current.classList.contains('type-video') ) {
					_videoPlay(current, true);
				}
				
				if( animate ) {
					const factor = index > currentIndex ? -1 : 1;
					const decx = 100;
					const ease = 'expoOut';
					
					if( old ) {
						gsap.to(old, { 
							x: decx * factor, 
							opacity: 0,
							duration: .5, 
							ease: ease, 
						});
					}
					
					gsap.fromTo(current, { 
						x: decx * factor * -1, 
						opacity: 0,
					}, { 
						x: 0, 
						opacity: 1, 
						duration: .5, 
						ease: ease, 
						delay:.1, 
					});
				}
				else {
					gsap.set(current, {
						x: 0, 
						opacity: 1
					});
				}
				
				currentIndex = newIndex;
			}
			
			_setIndex(currentIndex, false);
			
			// After this, it concerns only 
			// navigation between items 
			if( elements.length < 2 || ! nav ) {
				return;
			}
			
			const navPrev = nav.querySelector('.gallery--nav-prev');
			const navNext = nav.querySelector('.gallery--nav-next');
			
			navPrev.addEventListener('click', event => {
				event.preventDefault();
				_setIndex(currentIndex - 1);
			});
			
			navNext.addEventListener('click', event => {
				event.preventDefault();
				_setIndex(currentIndex + 1);
			});
			
			if( swipeEnabled ) {
				/*
				* Add swipe event listener on container
				*/
				const ztRegion = ZingTouch.Region(gallery, false, false);
				const panEvent = new ZingTouch.Pan({
					numInputs: 1,
					threshold: 50,
				});
				
				
				ztRegion.bind(gallery, panEvent, event => {
					
					const { currentDirection } = event.detail.data[0];
					const direction = getCardinalDirection(currentDirection);
					
					if( direction === 'W' || direction === 'E' ) {	
						// Within each of those special ZingTouch events, 
						// the originalEvent the browser emitted is stored.
						event.detail.events.forEach(e => e.originalEvent.preventDefault());
						const xMove = direction === 'W' ? 1 : -1;
						return _setIndex(currentIndex + xMove);
					}
				}, false);
			}
		});
	});
})();